import React from 'react';
import ConfigTheme from '@src/components/ConfigTheme';
import { Grid, Stack } from '@mui/material';
import UpdateFacility from '@src/components/UpdateFacility';
import BrandingSettings from './BrandingSettings';

const GeneralSettings = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={6}>
      <UpdateFacility />
    </Grid>
    <Grid item xs={12} md={6}>
      <Stack spacing={2}>
        <ConfigTheme />
        <BrandingSettings />
      </Stack>
    </Grid>
  </Grid>
);

export default GeneralSettings;
